<template>
  <div class="product" @click="onClick">
    <div v-if="isPopularProduct" class="popular">
      POPULAR
    </div>
    <img
      class="icon"
      :class="{ extra: hidePrice }"
      :src="product.icon"
      alt=""
    />
    <div
      class="points"
      :class="{
        hide: hidePrice,
      }"
    >
      <div class="amount">
        <span class="value">{{ productAmountLabel }}</span>
      </div>
      <span v-if="productBonus" class="plus">+</span>
      <div v-if="productBonus" class="bonus">
        <span class="value">{{ productBonusLabel }}</span>
      </div>
    </div>
    <div class="prices">
      <h2 class="price">{{ priceLabel }}</h2>
    </div>
    <button class="buy-btn">BUY NOW</button>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import { formatPriceUSD } from "@/store/utils/util.utils"

export default {
  props: ["product"],
  computed: {
    ...mapGetters("User", ["getUser"]),
    ...mapGetters("Store", ["products"]),
    ...mapGetters("Util", ["getPriceByPoint"]),
    amountMatchesPrice () {
      return Math.round(this.product.price) === this.productAmount
    },
    hidePrice () {
      return this.amountMatchesPrice && !this.productBonus
    },
    productAmount () {
      return this.getPriceByPoint(this.product.amount)
    },
    productAmountLabel () {
      return formatPriceUSD(this.productAmount)
    },
    productBonus () {
      return this.product.bonus
        ? this.getPriceByPoint(this.product.bonus)
        : null
    },
    productBonusLabel () {
      return formatPriceUSD(this.productBonus)
    },
    isPopularProduct () {
      const popularProduct = this.products.find((product) => {
        return product.price > 30 && product.price < 60
      })
      return popularProduct?.id === this.product.id
    },
    price () {
      // Treat X.99 formatted pricing as the rounded dollar amount
      return this.amountMatchesPrice
        ? this.productAmount
        : this.product.price
    },
    priceLabel () {
      return formatPriceUSD(this.price)
    },
  },
  methods: {
    ...mapMutations("Store", ["setSelectedProduct"]),
    ...mapMutations("Payment", ["setPaymentIntent"]),
    onClick () {
      if (!this.getUser) {
        window.location.href = "/login?from=/store/points"
      } else {
        this.setPaymentIntent(null)
        this.setSelectedProduct(this.product)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

* {
  margin: 0;
}

.hide {
  display: none !important;
}

.product {
  background: #fff;
  margin: 0 1rem;
  border-radius: 10px;
  width: 100%;
  max-width: 25rem;
  padding: 2rem 0 3rem;
  transition: all 0.5s ease-in-out;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  position: relative;

  @include tablet-down {
    margin-bottom: 2rem;
    max-width: 60rem;
  }

  @include phone-down {
    max-width: 90%;
  }

  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.33);
    transform: translateY(-0.5rem);
  }

  .popular {
    display: none;
  }

  &:last-child {
    .popular {
      position: absolute;
      right: 0;
      top: 1rem;
      font-family: $font-primary;
      font-size: 0.8rem;
      height: 2rem;
      width: 6rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f14950;
      line-height: 100%;
      font-weight: 700;
      color: #fff;
      letter-spacing: 0.13em;

      &::after {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        left: -1rem;
        right: 0;
        top: 0;
        bottom: 0;
        border-left: 1rem solid transparent;
        border-top: 1rem solid #f14950;
        border-bottom: 1rem solid #f14950;
      }
    }
  }

  .icon {
    width: 14rem;

    &.extra {
      padding: 4.25rem 0;
    }
  }

  .points {
    margin-top: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2d4b60;
    height: 5.5rem;
    color: #fff;

    .amount {
      display: flex;
      flex-direction: column;
    }

    .bonus {
      display: flex;
      flex-direction: column;
      color: #f9a821;
    }

    .plus {
      margin: 0 1rem;
      height: 2.4rem;
    }

    .value {
      font-family: $font-primary;
      font-weight: 700;
      font-size: 2.25rem;
    }

    .label {
      font-family: $font-primary;
      font-weight: 700;
      font-size: 1.15rem;
      letter-spacing: 2px;
    }
  }

  .prices {
    margin-top: 2rem;

    .price {
      font-family: $font-primary;
      font-weight: 300;
      font-size: 2.5rem;
      color: #3b3b3b;
      margin-bottom: 2rem;
    }
  }

  .buy-btn {
    outline: none;
    height: 5rem;
    width: calc(100% - 6rem);
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1.5px solid #3b3b3b;
    border-radius: 4px;
    font-family: $font-primary;
    font-weight: 600;
    font-size: 1.4rem;
    letter-spacing: 1.3px;
    color: #3b3b3b;

    &:hover {
      background-color: #000;
      border: 1.5px solid #000;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/store/pointStore/Product.vue